export type AppUser = {
  uid: string;
  email: string | null;
  emailVerified: boolean;
  displayName: string | null;
};

export type AppClaims = Record<string, unknown>;

export function toAppUser(fbUser: {
  uid: string;
  email: string | null;
  emailVerified: boolean;
  displayName?: string | null;
}): AppUser {
  return {
    uid: fbUser.uid,
    email: fbUser.email,
    emailVerified: fbUser.emailVerified,
    displayName: fbUser.displayName ?? null,
  };
}
